import { render, staticRenderFns } from "./goods_waterfall.vue?vue&type=template&id=227e2591&"
import script from "./goods_waterfall.vue?vue&type=script&lang=js&"
export * from "./goods_waterfall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports